export default {
  profile: (state) => {
    return state.profile;
  },
  profilePid: (state) => {
    return state.profilePid;
  },
  profileLoading(state) {
    return state.profileLoading;
  },
  profileUpdating(state) {
    return state.profileUpdating;
  },
  orgMeta(state) {
    return state.profile.org_meta || {};
  },
  stripeKey(state) {
    return state.profile.org_meta ? state.profile.org_meta.stripe_key : '';
  },
  orgStyles(state) {
    return state.profile.org_styles || {};
  },
  insideScorm(state) {
    return state.scormParameters !== null;
  },
  isTesterProfile(state) {
    return state.profile?.meta?.tester || false;
  },
  roleHasReports: (state) => {
    return state.role?.reports?.length;
  },
  roleHasPermission: (state) => (permission) => {
    const permissions = state.role?.permissions || [];
    return permissions.includes(permission);
  },
  roleRelationField: (state) => {
    const relation = state?.role?.relation;
    if (!relation) return null;
    return Array.isArray(relation) ? relation[0] : relation;
  },
  roleRelationFields: (state) => {
    const relations = state?.role?.relations;
    if (Array.isArray(relations) && relations.length) return relations;
    const relation = state?.role?.relation;
    if (!relation) return [];
    return Array.isArray(relation) ? relation : [relation];
  },
  profileRole: (state) => {
    return state?.role || null;
  },
  isSidebarOpen: (state) => {
    return state.isSidebarOpen;
  },
  profileFields: (state) => {
    return state.profileFields || {};
  },
  portalFieldSections: (state) => {
    const sections = state.profile?.org_meta?.field_sections || [];
    return [
      {
        title: 'Default',
        slug: '',
        locked: true,
      },
      ...sections,
    ];
  },
};
